(() => {
  function initialize(root) {
    root.querySelectorAll('[data-wsale-contact-form]').forEach((form) => {
      if (form.dataset.wsaleContactReady) return;
      form.dataset.wsaleContactReady = 'true';

      // Only enhance the outgoing payload. Native named fields remain the fallback.
      form.addEventListener('formdata', (event) => {
        const first = form.querySelector('[data-contact-first-name]');
        const last = form.querySelector('[data-contact-last-name]');
        const name = [first?.value.trim(), last?.value.trim()].filter(Boolean).join(' ');
        if (!name) return;
        event.formData.set('contact[name]', name);
        if (first) event.formData.delete(first.name);
        if (last) event.formData.delete(last.name);
      });
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
